/** Keep aligned with lib/mentor-identity.js. Voice names are delivery, not identity. */
export const AI_MENTOR = 'AI-Mentor';
export const AI_MENTOR_ROLE = 'Executive, career, and workplace mentoring';
